export default __webpack_public_path__ + "media/images/socials-facebook-8c718cea1e337060bc838227be619e6e.svg";